/**
 * The world's address and phone rules (LIS-1173): seller-free reference
 * data and the pure readers over it, the same for every seller. The server,
 * both clients and the identity store read them from here, through
 * `@libs/platform-wire/world` (Identity's contracts and buyer-identity-client,
 * which do not depend on platform-wire, import this directly). A seller's own policy (which
 * parts it asks, which countries it refuses) is never here: it travels on
 * the purchase.
 */
export { ISO_COUNTRIES, isoCountryName, type IsoCountry } from "../isoCountries";
export {
  countriesDialling,
  countryData,
  regionFits,
  regionOptions,
  type CountryData,
  type CountryFile,
  type RegionOption,
} from "./countries";
export {
  diallingCode,
  displayPhone,
  nationalPhone,
  phoneParts,
  readPhone,
  type DialledPhone,
} from "./phone";
export {
  CITY_LABELS,
  cityLabel,
  matchRegion,
  postcodeNoun,
  readPostcode,
  REGION_LABELS,
  regionLabel,
  ukNationOf,
  type UkNation,
  withPostcodeNoun,
} from "./address";
